export const videoBlockTitle = 'Creator videos';
export const topCreatorsCount = 4;
